import { useLoaderData, useNavigate } from "react-router-dom"
import AddPhoneNumber from "./AddPhoneNumber"
import {
    Box, Collapse, Link, Step, StepLabel, Stepper, Typography
} from "@mui/material"
import { useEffect, useState } from "react"
import AddPath from "./AddPath"
import ConfirmTerms from "./ConfirmTerms"

export default function RegisterStep() {
    const checkData = useLoaderData() as any
    const { phone_number = '', is_mall_opened = false } = checkData
    const [step, setStep] = useState(0)
    const navigate = useNavigate()
    useEffect(() => {
        if (!!phone_number && !!is_mall_opened) {
            navigate('/')
        } else {
            if (!phone_number) setStep(0)
            else setStep(1)
        }
    }, [])
    const stepList = ['휴대폰 번호', '약관 동의']

    return (
        <div style={{
            width: '100vw',
            height: '100vh',
            backgroundColor: '#ffffff'
        }}>
            <Box className="flex w-full flex-col items-center justify-center"
                sx={{
                    py: 10,
                    height: '100vh'
                }}
            >
                <Box className="flex w-full items-center justify-center flex-col">
                    <Stepper sx={{ width: '100%', maxWidth: '600px' }}
                        activeStep={step}>
                        {stepList.map((item, idx) => {
                            return (
                                <Step key={idx}>
                                    <StepLabel>{item}</StepLabel>
                                </Step>
                            )
                        })}
                    </Stepper>
                    <Box className="w-full relative" sx={{
                        maxWidth: '600px',
                        bgcolor: '#f6f6f6',
                        mt: 10,
                        borderRadius: '20px',
                        boxSizing: 'border-box',
                        p: 5
                    }}>
                        <Box className="absolute flex items-center justify-center" sx={{
                            top: -20,
                            right: '45%',
                            bgcolor: '#ff6aac',
                            aspectRatio: '1',
                            width: '40px',
                            borderRadius: '50%'
                        }}>
                            <Typography variant="h4" sx={{ color: 'white !important' }}><b>{step + 1}</b></Typography>
                        </Box>
                        <Collapse in={step === 0}>
                            <AddPhoneNumber setStep={setStep} />
                        </Collapse>
                        <Collapse in={step === 1}>
                            {/* <AddPath /> */}
                            <ConfirmTerms />
                        </Collapse>
                        <Box className="w-full flex justify-end" sx={{ mt: 2 }}>
                            <Link href="/logout">다른 계정으로 로그인하기</Link>
                        </Box>
                    </Box>
                    <div />
                </Box>
            </Box>
        </div>
    )
}